import React from 'react';
import categoryItemTheme from './categoryItem.scss';
import AssetItem from '../AssetItem/AssetItem';

const CategoryItem = props => (
  <AssetItem {...props} theme={categoryItemTheme} />
);

export default CategoryItem;
